import { useEffect, useState } from "react";

function usePageMode(customPageMode) {
  const [pageMode, setPageMode] = useState({
    list: true,
    view: false,
    new: false,
    edit: false,
    assign: false,
    filter: false,
    delete: false,
    reset: false
  });

  // If want a custom page mode. Example --> studentview :false
  useEffect(() => {
    if (customPageMode) {
      const newPageMode = { ...pageMode, ...customPageMode };
      setPageMode(newPageMode);
    }
  }, []);

  // sayfa modunu değiştirme
  /**
   * @param {("list"|"view"|"new"|"edit"|"assign"|"filter"|"delete"|"reset")} mode
   * @param {boolean} open
   * @param {Boolean} list
   */
  const changePageMode =
    (mode, open, list = false) =>
    (event) => {
      if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
        return;
      }

      const newPageMode = { ...pageMode };
      newPageMode.list = list;
      newPageMode[mode] = open;

      setPageMode(newPageMode);
    };

  /**
   * @param {array} modeList
   */
  const changeMultiplePageMode = (modeList) => (event) => {
    if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }

    const newPageMode = { ...pageMode };

    modeList.forEach((mode) => {
      newPageMode[mode.name] = mode.open;
    });

    setPageMode(newPageMode);
  };

  return { pageMode, setPageMode, changePageMode, changeMultiplePageMode };
}

export default usePageMode;
